import { reclamacionService } from '@/_services';

export const reclamacionCliente = {
  namespaced: true,
  state: {
    list: null,
    status: {},
  },
  actions: {
    getReclamaciones({ commit }, search) {
      commit('getReclamacionesRequest');
      reclamacionService.getReclamaciones(search)
        .then(
          reclamaciones => commit('getReclamacionesSuccess', reclamaciones),
          error => commit('getReclamacionesFailure', error)
        );
    },
  },
  mutations: {
    getReclamacionesRequest(state) {
      state.list = {};
      state.status = { loading: true };
    },
    getReclamacionesSuccess(state, reclamaciones) {
      state.list = reclamaciones;
      state.status = { loaded: true };
    },
    getReclamacionesFailure(state, error) {
      state.list = {};
      state.status = { error }
    }
  }
}